/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TargetCrosshairIcon20Solid = forwardRef('TargetCrosshairIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.875 10a8.125 8.125 0 1 1 16.25 0 8.125 8.125 0 0 1-16.25 0Zm2.358-1.125a5.881 5.881 0 0 1 4.642-4.642V6.25a1.125 1.125 0 0 0 2.25 0V4.233a5.881 5.881 0 0 1 4.642 4.642H13.75a1.125 1.125 0 0 0 0 2.25h2.017a5.881 5.881 0 0 1-4.642 4.642V13.75a1.125 1.125 0 0 0-2.25 0v2.017a5.881 5.881 0 0 1-4.642-4.642H6.25a1.125 1.125 0 0 0 0-2.25H4.233Z" })));
});
